import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { floorplanRooms, zoneColors } from "../data/floorplan";

export default function MiniMap({ activeRoomId }) {
  const navigate = useNavigate();
  const [hoveredRoom, setHoveredRoom] = useState(null);

  return (
    <div className="mini-map-container" style={{ position: "relative", width: "100%", maxWidth: "1000px", margin: "0 auto", borderRadius: "var(--radius-lg)", overflow: "hidden", border: "1px solid var(--line)" }}>
      <img
        src={process.env.PUBLIC_URL + "/floorplan.png"}
        alt="Facility Map"
        style={{ width: "100%", height: "auto", display: "block" }}
      />
      <svg
        viewBox="0 0 2384 3370"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
        xmlns="http://www.w3.org/2000/svg"
      >
        {floorplanRooms.map((room) => {
          const colors = zoneColors[room.zone];
          const isHovered = hoveredRoom?.id === room.id;
          const isActive = activeRoomId === room.id;
          
          return (
            <g
              key={room.id}
              onClick={() => navigate(`/room/${room.id}`)}
              onMouseEnter={() => setHoveredRoom(room)}
              onMouseLeave={() => setHoveredRoom(null)}
              style={{ cursor: "pointer" }}
            >
              <rect
                x={room.x}
                y={room.y}
                width={room.w}
                height={room.h}
                rx="8"
                fill={isActive ? colors.text : isHovered ? colors.hover : colors.fill}
                stroke={isActive ? colors.text : isHovered ? colors.text : colors.stroke}
                strokeWidth={isActive || isHovered ? 5 : 3}
                fillOpacity={isActive ? 0.8 : isHovered ? 0.55 : 0.35}
              />
              <text
                x={room.x + room.w / 2}
                y={room.y + room.h / 2}
                textAnchor="middle"
                dominantBaseline="central"
                fill={isActive ? "#fff" : colors.text}
                fontSize={room.w < 120 ? 18 : room.w < 200 ? 22 : 26}
                fontWeight="700"
                fontFamily="var(--body)"
                pointerEvents="none"
              >
                {room.label.length > 14 && room.w < 200
                  ? room.label.split(" ").map((word, i, arr) => (
                      <tspan
                        key={i}
                        x={room.x + room.w / 2}
                        dy={i === 0 ? `-${(arr.length - 1) * 12}px` : "26px"}
                      >
                        {word}
                      </tspan>
                    ))
                  : room.label}
              </text>
            </g>
          );
        })}
      </svg>
      {/* Tooltip */}
      {hoveredRoom && (
        <div className="floorplan-tooltip" style={{ position: "absolute", top: 16, left: "50%", transform: "translateX(-50%)", zIndex: 10 }}>
          <strong>{hoveredRoom.label}</strong>
        </div>
      )}
    </div>
  );
}
